import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class CustomMouse {
  constructor(target, options) {
    _defineProperty(this, "target", void 0);
    _defineProperty(this, "options", void 0);
    _defineProperty(this, "currentProgress", void 0);
    this.target = target;
    this.options = options || {};
    this.currentProgress = {
      x: 0.5,
      y: 0.5,
      v: {
        x: 0,
        y: 0
      },
      active: true
    };
    this.play();
  }
  progress(_ref) {
    let {
      x,
      y,
      v,
      active
    } = _ref;
    this.currentProgress = {
      x,
      y,
      v,
      active
    };
  }
  cancel() {
    this.currentProgress = {
      x: 0.5,
      y: 0.5,
      v: {
        x: 0,
        y: 0
      }
    };
  }
  getProgress() {
    return this.currentProgress;
  }
  play() {
    if (this.options.transition && this.target) {
      this.target.style.transition = this.options.transition;
    }
  }
}
export function create(options) {
  return target => new CustomMouse(target, options);
}
//# sourceMappingURL=CustomMouse.js.map